'use strict';

let currentURL;
const variantSelector = document.querySelector('.rio-options');
const nav = document.querySelector('.header__inline-menu');
const linkDYR = document.querySelector('.design-rug');
const btnSaveRugField = document.querySelector('.btn-save-rug-field');
const btnSaveBorder = document.querySelector('.btn-save-border');
const btnSaveWallcovering = document.querySelector('.btn-save-wallcovering');
const mediaGallery = document.querySelector('.rio-media-gallery');
const updateMessage = document.querySelector('.update-message');
const variantPattern = document.getElementById('variant-pattern');
const variantPatternRepeat = document.getElementById('variant-pattern-repeat');
const variantBacking = document.getElementById('variant-backing');
const variantConstruction = document.getElementById('variant-construction');
const variantComposition = document.getElementById('variant-composition');
const variantWidth = document.getElementById('variant-width');

localStorage.removeItem('selectedVariant');

const grabURLDelay = function() {
  setTimeout(function() {
    currentURL = window.location.href;
    selectedVariantID = currentURL.split('variant=')[1];
    updateVariant();
  }, 200
  )
}

const grabURL = function() {
  if (!window.location.href.includes('variant=')) return;
  currentURL = window.location.href;
  selectedVariantID = currentURL.split('variant=')[1];
}

const setStorage = function() {
  localStorage.setItem('selectedVariant', JSON.stringify({product: thisProduct.camel, variant: thisProduct.variants[selectedVariantID].title, productID: thisProduct.id, variantID: thisProduct.variants[selectedVariantID].id}))
}

const removeStorage = function(e) {
  if (!e.target.href === '/pages/design-your-rug') return;
  localStorage.removeItem('selectedVariant');
}

const updateVariant = function() {
  if (document.querySelector('.form')) document.querySelector('.form').querySelector('[name="id"]').value = selectedVariantID;
}

window.addEventListener('locationchange', function() {
  if (currentURL === window.location.href) return;
  grabURLDelay()
});

grabURL();
updateVariant();